import { createSlice } from '@reduxjs/toolkit';
import { getFieldLabelsAsync } from './asyncActions';
import { setFieldLabelOverrides } from 'i18n/fieldLabels';
import { logoutAction } from 'features/common/commonSlice';

export interface FieldLabelsState {
  /** Etiqueta sobrescrita por código de campo. Vacío = mandan los literales del i18n. */
  labels: Record<string, string>;
  status: null | 'idle' | 'loading' | 'failed';
}

const initialState: FieldLabelsState = {
  labels: {},
  status: null,
};

export const fieldLabelsSlice = createSlice({
  name: 'fieldLabels',
  initialState,
  reducers: {
    resetFieldLabels: (state) => {
      state.labels = {};
      state.status = null;
      setFieldLabelOverrides({});
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFieldLabelsAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getFieldLabelsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.labels = action.payload ?? {};
      })
      .addCase(getFieldLabelsAsync.rejected, (state) => {
        // Sin overrides se cae a los literales del i18n, que es el comportamiento de
        // siempre: no bloqueamos nada por esto.
        state.status = 'failed';
        state.labels = {};
      })
      // Las etiquetas son del grupo del usuario. Si no se limpian al salir, el siguiente
      // que entre en la misma pestaña vería las del anterior hasta que resuelva su fetch.
      .addCase(logoutAction, (state) => {
        state.labels = {};
        state.status = null;
        setFieldLabelOverrides({});
      });
  },
});

export const { resetFieldLabels } = fieldLabelsSlice.actions;

export default fieldLabelsSlice.reducer;
